import script from "./monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./monitor.vue?vue&type=script&setup=true&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=0317116f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0317116f"]])

export default __exports__